document.addEventListener("DOMContentLoaded", () => {
  const sizeInputs = document.querySelectorAll("input[name='size']");
  const kamado = document.getElementById("kamado");
  const otherKamado = document.getElementById("otherKamado");
  const otherKamadoInput = document.getElementById("otherKamadoInput");
  const wood = document.getElementById("wood");
  const worktop = document.getElementById("worktop");
  const totalPrice = document.getElementById("totalPrice");
  const summarySize = document.getElementById("summary-size");
  const summaryKamado = document.getElementById("summary-kamado");
  const summaryWood = document.getElementById("summary-wood");
  const summaryWorktop = document.getElementById("summary-worktop");
  const hiddenSize = document.getElementById("hiddenSize");
  const hiddenKamado = document.getElementById("hiddenKamado");
  const hiddenWood = document.getElementById("hiddenWood");
  const hiddenWorktop = document.getElementById("hiddenWorktop");
  const hiddenPrice = document.getElementById("hiddenPrice");

  if (!sizeInputs.length || !kamado || !wood || !worktop || !totalPrice) return;

  function formatPrice(price) {
    return new Intl.NumberFormat("nl-NL", {style:"currency", currency:"EUR", maximumFractionDigits:0}).format(price);
  }

  function updateConfigurator() {
    const selectedSize = document.querySelector("input[name='size']:checked");
    if (!selectedSize) return;

    document.querySelectorAll(".size-card").forEach(card => card.classList.remove("selected"));
    selectedSize.closest(".size-card")?.classList.add("selected");

    const isCustom = selectedSize.dataset.label === "Maatwerk";
    const basePrice = Number(selectedSize.value);
    const woodPrice = Number(wood.value);
    const worktopPrice = Number(worktop.value);
    const total = basePrice + woodPrice + worktopPrice;

    totalPrice.textContent = isCustom ? "Op aanvraag" : formatPrice(total);
    summarySize.textContent = selectedSize.dataset.label;

    if (kamado.value === "other") {
      otherKamado.style.display = "block";
      summaryKamado.textContent = otherKamadoInput.value || "Eigen kamado";
    } else {
      otherKamado.style.display = "none";
      summaryKamado.textContent = kamado.value;
    }

    summaryWood.textContent = wood.options[wood.selectedIndex].text;
    summaryWorktop.textContent = worktop.options[worktop.selectedIndex].text;

    if (hiddenSize) hiddenSize.value = summarySize.textContent;
    if (hiddenKamado) hiddenKamado.value = summaryKamado.textContent;
    if (hiddenWood) hiddenWood.value = summaryWood.textContent;
    if (hiddenWorktop) hiddenWorktop.value = summaryWorktop.textContent;
    if (hiddenPrice) hiddenPrice.value = isCustom ? "Prijs op aanvraag" : formatPrice(total);
  }

  sizeInputs.forEach(input => input.addEventListener("change", updateConfigurator));
  kamado.addEventListener("change", updateConfigurator);
  otherKamadoInput?.addEventListener("input", updateConfigurator);
  wood.addEventListener("change", updateConfigurator);
  worktop.addEventListener("change", updateConfigurator);
  updateConfigurator();
});